import { useMutation } from '@tanstack/react-query'

import { dataOrThrow, type PostIntakeChatBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

/**
 * Sends one turn of the intake chat via `POST /api/portal/pets/:id/intake`.
 * Nothing is cached server-side, so there is nothing to invalidate.
 */
export function usePostIntakeChat(patientId: string) {
  const api = usePortalApi()

  return useMutation({
    mutationFn: async (body: PostIntakeChatBody) =>
      dataOrThrow(await api.post('/pets/:id/intake', { params: { id: patientId }, body })),
  })
}
